// Projects data for the "Participate in build" section.
// slogan: one-line project positioning (keep it under ~90 chars).
// contributions: what Air actually did in each project — replace the drafts
// below with real, verifiable facts (numbers where possible).
// discord: real member stats fetched from the public invite API
// (api/v9/invites/<invite>?with_counts=true). Only add an entry once the
// official invite code is verified — "fiamma" resolves to an unrelated
// server, do NOT use it.
export const mockProjects = [
  {
    name: "Pharos",
    slogan: "Pharos is a high-performance EVM-compatible public chain built by the former Ant team. It is inclusive finance and AI L1 for RWA/RealFi, making real value open to everyone.",
    contributions: [
      "Moderating the official Discord: verify flow, Q&A and anti-spam, 10h+ daily presence",
      "Relaying community feedback and common technical issues to the core team",
      "Turning dev-team updates into clear, community-friendly announcements",
      "Managed support tickets and handled user inquiries",
      "Wrote tutorial documentation and recorded tutorial videos for users",
      "Managed the Chinese regional X account (@Pharos_CN)",
      "Organized community mini-games and engagement activities",
    ],
    twitter: "https://x.com/pharos_network",
    website: "https://www.pharosnetwork.xyz/",
    avatar: "/images/pharos.png",
    logoColor: "#0007B8",
    role: "MOD",
    discord: { members: 971267, online: 5435, invite: "pharos" },
  },
  {
    name: "Fiamma",
    slogan: "Trust-minimized Bitcoin bridge & ZK verification layer, powered by BitVM2.",
    contributions: [
      "Continued community moderation and user support",
      "Compiled community FAQs and onboarding tutorials",
    ],
    twitter: "https://x.com/fiamma_labs",
    website: "https://www.fiammalabs.io/",
    avatar: "/images/fiamma.png",
    logoColor: "#f7931a",
    role: "Ambassador",
    discord: { members: 658, online: 108, invite: "fiammalabs" },
  },
  {
    name: "AINX",
    slogan: "DePIN network aggregating global compute for AI inference & training.",
    contributions: [
      "Moderating the Discord community and managing member onboarding",
    ],
    twitter: "https://x.com/ainx_io",
    website: "https://ainx.io/",
    avatar: "/images/ainx.png",
    logoColor: "#E31A37",
    role: "MOD",
  },
];
